import type { Property, PropertyInput } from "@/types";
import { apiClient } from "./client";

export const propertyService = {
  list: async (): Promise<Property[]> => {
    const { data } = await apiClient.get<Property[]>("/admin/properties");
    return data;
  },

  create: async (body: PropertyInput): Promise<Property> => {
    const { data } = await apiClient.post<Property>("/admin/properties", body);
    return data;
  },

  get: async (id: string): Promise<Property> => {
    const { data } = await apiClient.get<Property>(`/admin/properties/${id}`);
    return data;
  },

  update: async (id: string, body: PropertyInput): Promise<Property> => {
    const { data } = await apiClient.put<Property>(`/admin/properties/${id}`, body);
    return data;
  },

  /** Retry the Channex connection for a pending property. Idempotent. */
  connect: async (id: string): Promise<Property> => {
    const { data } = await apiClient.post<Property>(`/admin/properties/${id}/connect`);
    return data;
  },

  remove: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/properties/${id}`);
  },

  /** Public chatbot link for the property (token issued lazily server-side). */
  chatbotLink: async (id: string): Promise<{ link_url: string }> => {
    const { data } = await apiClient.get<{ link_url: string }>(
      `/admin/properties/${id}/chatbot-link`
    );
    return data;
  },
};
